export const FAQS = [
  {
    question: "What makes a pool fence legal in WA?",
    answer:
      "Minimum 1.2m height, gaps under 100mm, a 900mm non-climbable zone, and a self-closing, self-latching gate that opens away from the water — all to AS 1926.1, verified by council inspection. We build to spec, book the inspection and hand over the certification paperwork.",
  },
  {
    question: "Do I need council approval for a retaining wall?",
    answer:
      "In WA, walls over 500mm generally need council approval and engineering. We prepare the engineering drawings, lodge the application and build to the approved design — it's included in the quoted process.",
  },
  {
    question: "Who pays for a boundary fence?",
    answer:
      "Under WA's Dividing Fences Act, neighbours usually share the cost of a \"sufficient\" dividing fence 50/50. We provide split quotes and a letter template you can hand next door.",
  },
  {
    question: "How high can my fence be at the front?",
    answer:
      "R-Codes allow solid front fencing to 1.2m, anything taller must be visually permeable — open garrison and blade spacing satisfy this. We check your local planning scheme before we quote.",
  },
  {
    question: "How long does installation take?",
    answer:
      "Most residential fence runs are done in 1–2 days; retaining walls 2–4 days depending on height and access. Supply lead times are confirmed in your written quote.",
  },
  {
    question: "What happens in a power outage (automated gates)?",
    answer:
      "Battery backup runs the gate for around 10 cycles, and every motor includes a manual release key. Solar power packs are available for gates far from mains power.",
  },
  {
    question: "Can you match my existing fence colour?",
    answer:
      "Yes — the full Colorbond colour range is standard, and we can custom powder-coat to match anything else, including timber-look woodgrain finishes.",
  },
  {
    question: "What warranty do I get?",
    answer:
      "Ten years on frames and workmanship, two years on Centurion motors, and glass certified to AS 1926.1. Warranty terms are printed on every quote.",
  },
  {
    question: "Do you remove the old fence?",
    answer:
      "Yes — removal and disposal is a standard add-on. Asbestos fencing is handled separately by our licensed removal crew, with an air-clearance certificate on completion.",
  },
  {
    question: "How does payment work?",
    answer:
      "Free measure first, then a fixed written quote. A deposit secures your booking and the balance is due after the completed walkthrough — card or EFT, all prices include GST.",
  },
];
